import {nfmsPost} from "./handler/NfmsClient";
import {getNodeId} from "./Utils";
import {getUserLogin} from "./components/permissions/PermissionContext";

async function callNFMS(operation, requestBody) {
    try {
        const response = await nfmsPost(operation, requestBody);
        if (response && response.status === 200) {
            return {valid: true, data: response.data};
        }
        return {valid: false, data: {}};
    } catch (e) {
        return {valid: false, data: {}};
    }
}

export async function fetchAllPrograms() {
    const userAlias = await getUserLogin();
    const result = await callNFMS("GetPrograms", {userAlias});
    if (result.valid && result.data.programs) {
        return result.data.programs.map(program => program.name);
    }
    return [];
}

export async function fetchFeatures(program) {
    const result = await callNFMS("GetFeatures", {programId: program});
    if (result.valid && result.data.features) {
        return result.data.features.map(feature => feature.name);
    }
    return [];
}

export async function fetchFeaturesForProgram(program) {
    const result = await callNFMS("GetFeatures", {programId: program});
    if (result.valid && result.data.features) {
        return result.data.features;
    }
    return [];
}

export async function fetchConfigs(feature, configStore) {
    const result = await callNFMS("GetConfigurations", {featureId: feature, configStore: configStore});
    if (result.valid && result.data.configurations) {
        return result.data.configurations;
    }
    return [];
}

export async function fetchTemplates(configType) {
    const result = await callNFMS("GetTemplates", {configType: configType});
    if (result.valid && result.data.templates) {
        return result.data.templates;
    }
    return [];
}

export async function fetchAttributesForNode() {
    const nodeId = getNodeId();
    if (nodeId) {
        const userAlias = await getUserLogin();
        const [featuresResult, programsResult] = await Promise.all([
            callNFMS("GetFeatures", {nodeId: nodeId}),
            callNFMS("GetPrograms", {nodeId: nodeId, userAlias})
        ]);
        const featureList = (featuresResult.valid && featuresResult.data.features) ? featuresResult.data.features : [];
        const programList = (programsResult.valid && programsResult.data.programs) ? programsResult.data.programs : [];
        return programList.concat(featureList);
    }
    return [];
}

export async function fetchCycleConfigs(stationCode) {
    const result = await callNFMS("GetCycleConfigs", {stationCode: stationCode});
    if (result.valid && result.data.cycleConfigs) {
        return result.data.cycleConfigs;
    }
    return [];
}



// WEBPACK FOOTER //
// ./src/NetworkUtils.js